export default __webpack_public_path__ + "images/b5038eabd4731c49cebf89e08782bd01-adult_small.webp";